import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { AppContextProvider } from '../../AppLoader';
import { EnforcementCard } from './EnforcementCard';
import { ChooseVerificationMethodContent } from './ChooseVerificationMethodContent';
import { ButtonWithLoader } from '../../ButtonWithLoader/ButtonWithLoader';
import { HelpCircleTooltip } from '../WixAppEnforcement/HelpCircleTooltip';
import { ThemedText, ThemedTextButton } from '../../ThemedComponents';
import { SkipEnforcementButton } from './SkipEnforcementButton';
import { dataHooks } from '../../../dataHooks';
import { BI_SCREEN_NAMES } from '../../../stores/constants';

export const ChooseVerificationMethodRedesign: React.FC = observer(() => {
  const { t } = useTranslation();
  const {
    rootStore,
    rootStore: {
      postLoginStore,
      postLoginStore: { premiumUsers2FaEnforcementStore: store },
      displayStore: { preset },
    },
  } = useContext(AppContextProvider);

  const learnMoreLink = `https://support.wix.com/${rootStore.language.locale}/article/secure-your-account-with-2-step-verification`;
  const showHelpCircle =
    !!store.messagePrefix && !store.twoFASettings.ownerAppMethod;

  return (
    <EnforcementCard
      title={t(`${store.messagePrefix}premium.users.2fa.enforcement.title`)}
      subtitle={store.subtitle}
      priority="primary"
      topRightAction={showHelpCircle ? <HelpCircleTooltip /> : undefined}
      primaryButton={
        <ButtonWithLoader
          skin={preset.buttonDesign?.skin ?? 'standard'}
          onClick={store.primaryButtonAction}
        >
          {store.primaryButtonText}
        </ButtonWithLoader>
      }
      skip={
        <SkipEnforcementButton
          dataHook={dataHooks.postLogin.common.skip}
          screenName={BI_SCREEN_NAMES.CHOOSE_VERIFICATION_METHOD}
        />
      }
      footer={
        store.isWixAppEnforcement ? undefined : (
          <ThemedText secondary size="tiny">
            <Trans i18nKey="premium.users.2fa.enforcement.footer">
              Why is 2-step verification crucial for account security?
              <ThemedTextButton
                dataHook={dataHooks.postLogin.common.accountSettingsTextButton}
                as="a"
                onClick={() => {
                  postLoginStore.sendAccountSettingBiEvents();
                  rootStore.navigationStore.redirect(learnMoreLink);
                }}
                size="tiny"
                skin="standard"
              >
                Learn more
              </ThemedTextButton>
            </Trans>
          </ThemedText>
        )
      }
    >
      <ChooseVerificationMethodContent padding="18px 0px 0px 0px" />
    </EnforcementCard>
  );
});
